import '../components/ChannelPreview';
import '../components/ChannelPage';
import '../components/IndexContent';

import 'vidstack/player';
import 'vidstack/player/layouts/default';
import 'vidstack/player/ui';


// Match against /channel/[channelId]
const channelPathMatch = window.location.pathname.match(/^\/channel\/([^\/]+)$/);
if (channelPathMatch) {
  const channelSlug = channelPathMatch[1];

  const channelPage = document.createElement('channel-page');
  channelPage.setAttribute('channelSlug', channelSlug);

  const indexContent = document.getElementById('index-content')
  indexContent?.remove()

  document.body.appendChild(channelPage)
} else {
  const creatorPathMatch = window.location.pathname.match(/^\/creator\/([^\/]+)$/);
  if (creatorPathMatch) {
    const creatorSlug = creatorPathMatch[1];

    const creatorPage = document.createElement('creator-page');
    creatorPage.setAttribute('creatorSlug', creatorSlug);

    document.getElementById('index-content')?.remove();
    document.body.appendChild(creatorPage);
  } else {
    const channelList = document.createElement('channel-page-content');
    document.body.appendChild(channelList)
  }
}
